import { DotsThreeVertical } from '@phosphor-icons/react';
import { useState } from 'react';
import { useTheme } from '@emotion/react';
import { ContextMenu, MenuOptionProps } from './ContextMenu';

type DotsMenuButtonProps = {
  menuOptions: MenuOptionProps[];
};

export const DotsMenuButton = ({ menuOptions }: DotsMenuButtonProps) => {
  const theme = useTheme();
  // Anchor the menu to the button element (not click coordinates) so MUI positions
  // it synchronously relative to a real DOM node — this avoids the top-left flash /
  // jump the coordinate-based anchorPosition path produced on first paint.
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const isMenuOpen = Boolean(anchorEl);

  const handleDotsMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  return (
    <div
      className="dotsMenu"
      style={{ ...(isMenuOpen ? { display: 'flex' } : {}), position: 'relative', width: '18px' }}
    >
      <button className="dotsMenuBtn" onClick={handleDotsMenuClick}>
        <DotsThreeVertical
          data-testid="dots_icon"
          data-color={theme.palette.fg.secondary}
          data-size="16"
          color={theme.palette.fg.secondary}
          size={16}
        />
      </button>
      {anchorEl && (
        <ContextMenu
          openMenu={isMenuOpen}
          options={menuOptions}
          onClose={handleCloseMenu}
          anchorEl={anchorEl}
        />
      )}
    </div>
  );
};
